import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EdiPricat, GungEdiMessageItem } from '../../../models/edi';
import { EdiPricatActionConfigService } from '../../../services/edi-pricat-action-config/edi-pricat-action-config.service';
import { EdiService } from '../../../services/edi/edi.service';
import { EdiRowTable, EdiRowTableType } from '../edi-row-table/edi-row-table.component';
import { TranslateService } from '@ngx-translate/core';
import { BackendFeatureService } from '../../../services/backend-feature.service';
import { EDI_VIEWER_FEATURE_ID } from '../../../services/edi/edi-viewer-compatibility.service';

@Component({
  selector: 'lib-edi-pricat-detail',
  templateUrl: './edi-pricat-detail.component.html',
  styleUrls: ['./edi-pricat-detail.component.css'],
  standalone: false
})
export class EdiPricatDetailComponent implements OnInit {
  protected route = inject(ActivatedRoute);
  protected ediService = inject(EdiService);
  protected translateService = inject(TranslateService);
  public actionConfigService = inject(EdiPricatActionConfigService);
  protected backendFeatureService = inject(BackendFeatureService);
  documentViewerEnabled$ = this.backendFeatureService.isActivated(EDI_VIEWER_FEATURE_ID);

  pricatId: string;
  pricatData: EdiPricat;
  itemsColumns: EdiRowTable[] = [];

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.pricatId = params.id;
      this.ediService.getPricat(this.pricatId).subscribe(response => {
        this.pricatData = response;
        this.itemsColumns = this.buildItemColumns(this.pricatData.items);
      });
    });
  }

  private buildItemColumns(items: GungEdiMessageItem[]): EdiRowTable[] {
    const fixedColumns: EdiRowTable[] = [
      {
        header: 'IMAGE',
        type: EdiRowTableType.IMAGE,
        getValue: (item: GungEdiMessageItem) => item?.extra?.images
      },
      {
        header: 'ITEM_ID',
        type: EdiRowTableType.TEXT,
        getValue: (item: GungEdiMessageItem) => {
          let str = '';
          if (item.ids.gungId) {
            if (!!str) {
              str += '\n';
            }
            str += this.translateService.instant('ID', {}) + ': ' + item.ids.gungId;
          }
          if (item.ids.ean13) {
            if (!!str) {
              str += '\n';
            }
            str += this.translateService.instant('EAN13', {}) + ': ' + item.ids.ean13;
          }
          if (item.ids.upca) {
            if (!!str) {
              str += '\n';
            }
            str += this.translateService.instant('UPCA', {}) + ': ' + item.ids.upca;
          }
          if (item.ids.buyerId) {
            if (!!str) {
              str += '\n';
            }
            str += this.translateService.instant('BUYER', {}) + ': ' + item.ids.buyerId;
          }
          return str;
        }
      },
      {
        header: 'NAME',
        type: EdiRowTableType.TEXT,
        getValue: (item: GungEdiMessageItem) => item.name || ''
      }
    ];

    const extraKeys = new Set<string>();
    for (const item of items || []) {
      for (const key of Object.keys(item.extra || {})) {
        extraKeys.add(key);
      }
    }

    const extraColumns: EdiRowTable[] = Array.from(extraKeys).map(key => ({
      header: key,
      type: EdiRowTableType.TEXT,
      getValue: (item: GungEdiMessageItem) => {
        const val = item.extra?.[key];
        if (val == null) {
          return '';
        }
        if (typeof val === 'object') {
          return JSON.stringify(val);
        }
        return String(val);
      }
    }));

    return [...fixedColumns, ...extraColumns];
  }
}
